import React from "react";
import style from "./styles/Common.module.scss";
import { useSelector } from "react-redux";
import ErrorBoundary from "./ErrorBoundary";
import { CircularProgress } from "@material-ui/core";

const LazyLoader = (props) => {
  //   const company = useSelector((state) => state.companyInfo);
  //   const themePrimary = company.color ? company.color : "black";

  return (
    // <ErrorBoundary>
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        textAlign: "center",
      }}
    >
      <div>
        <div
          style={{
            color: "#074481",
          }}
        >
          <CircularProgress />
        </div>
        <div
          style={{
            color: "#074481",
          }}
        >
          <span>Loading Content...</span>
        </div>
      </div>
    </div>
    // </ErrorBoundary>
  );
};

export default LazyLoader;
